<div class="body">
  <form class="form"
  (submit)="onFormSubmit($event)">
    <input placeholder=" Search"
    class="input" (input)="term = $event.target.value"/>
  </form>
</div>


